// This function adds styles at certain breakpoints based on the width of all the elements in the header
export function setBreakpointsDynamically(breadcrumbElem) {
	function selectBreadcrumbElem() {
		if (breadcrumbElem === undefined) {
			return document.getElementById("breadcrumb")
		}
		return breadcrumbElem;
	}
	const breadcrumb = selectBreadcrumbElem();
	const crumbList = breadcrumb.getElementsByTagName("li");

	// Create the style tag to edit
	const embeddedStyleId = "responsiveBreadcrumbStyles";
	let embeddedStyle = document.getElementById(embeddedStyleId);

	if (!embeddedStyle) {
		// Initial creation of the style tag that can be updated later
		const embedStyle = document.createElement('style');
		embedStyle.type = 'text/css';
		embedStyle.id = embeddedStyleId; // In case we need to grab it again later

		// Add it to the page
		document.getElementsByTagName('head')[0].appendChild(embedStyle);

		// Repoint variable to this newly created element
		embeddedStyle = embedStyle;
	}

	// Now measure up the items in the header...
	// Calculate the total width of the breadcrumb when on a wide screen
	let breadcrumbWidth = 20; // Hadrcoding this. The breadbrumb has 10px of padding-left and padding-right
	let lastCrumbWidth;
	for (var index = 0; index < crumbList.length; index++) {
		if ((crumbList.length - 1) === index) {
			lastCrumbWidth = crumbList[index].clientWidth;
		}
		breadcrumbWidth += crumbList[index].clientWidth;
	}

	const breadcrumbPadding = 8; // @todo: this is hard coded. It should be calculated or taken from a scss vars (if that's possible)
	const condensedCrumbSizePx = 100; // @todo: this is hard coded. It should be calculated or taken from a scss vars (if that's possible)

	// breadcrumbViewportDifference pixel values is based on: Header padding (20 + 20)  +  Hamburger box (28 + 8 + 8 - 20)  +  Logo (103)  +  aside (105)
	let breadcrumbViewportDifference = 272; // @todo: this is hard coded. It should be calculated or taken from a scss vars (if that's possible)
	// If the toggle esists  on the page we need to factor this in to our measurements
	const toggle = document.getElementById("nav-tree-user-toggle");
	if (toggle) {
		breadcrumbViewportDifference += toggle.clientWidth + 20; // It also has a 20px margin
	}

	const extraAmount = 8;// Added an arbitrary '8' for good measure to make sure there's no overlap
	const breadcrumbBreakpointLevel1 = breadcrumbWidth + breadcrumbPadding + breadcrumbPadding + breadcrumbViewportDifference + extraAmount;
	const breadcrumbBreakpointLevel2 = condensedCrumbSizePx * (crumbList.length - 1) + lastCrumbWidth + breadcrumbViewportDifference + extraAmount;
	const breadcrumbBreakpointLevel3 = condensedCrumbSizePx * crumbList.length + breadcrumbViewportDifference + extraAmount;

	let embedMediaQuery = `
			/* Style injected by responsiveBreadcrumbs */
			@media (max-width: ` + breadcrumbBreakpointLevel1 + `px) {
				#breadcrumb li:not(:last-child) {
					max-width: ` + condensedCrumbSizePx + `px;
				}
				#breadcrumb .icon,
				#breadcrumb .crumb-icon {
					display: none;
				}
			}
		`;
	if (breadcrumbBreakpointLevel2 <= breadcrumbBreakpointLevel1) {
		embedMediaQuery += `
			@media (max-width: ` + breadcrumbBreakpointLevel2 + `px) {
				#breadcrumb li {
					max-width: ` + condensedCrumbSizePx + `px;
				}
			}
		`;
	} else {
		embedMediaQuery += `
			/* Style injected by responsiveBreadcrumbs */
			@media (max-width: ` + breadcrumbBreakpointLevel1 + `px) {
				#breadcrumb li {
					max-width: ` + condensedCrumbSizePx + `px;
				}
				#breadcrumb .icon,
				#breadcrumb .crumb-icon {
					display: none;
				}
			}
		`;
	}
	if (breadcrumbBreakpointLevel3 < breadcrumbBreakpointLevel1) {
		embedMediaQuery += `
			@media (max-width: ` + breadcrumbBreakpointLevel3 + `px) {
				#breadcrumb {
					display: none;
				}
			}
		`;
	}
	embeddedStyle.innerHTML = embedMediaQuery;
}
